const endpointConfig = {
  personalDashboardHisense: {
    allocation: '/v1_4/custom/qualita/dashboard/allocation',
    provinceData: '/v1_4/custom/qualita/dashboard/chart-province',
    filterOptions: '/v1_4/custom/qualita/dashboard/filter-options',
    monitoringList: '/v1_4/custom/qualita/dashboard/monitoring-list',
    monitoringDetailInstitute: '/v1_4/custom/qualita/dashboard/institute-detail',
    monitoringDetailTracking: '/v1_4/custom/qualita/dashboard/institute-detail-tracking',
    monitoringDetailInstalled: '/v1_4/custom/qualita/dashboard/institute-detail-installed',
    installedByResi: '/v1_4/custom/qualita/dashboard/installed-by-resi',
    export: '/v1_4/custom/qualita/dashboard/export-resi',
    inputProblem: '/v1_4/custom/qualita/dashboard/update-terkendala',
    getProblem: '/v1_4/custom/qualita/dashboard/get-terkendala',
    scheduled: '/v1_4/custom/qualita/dashboard/get-scheduled',
    sync: '/v1_4/custom/qualita/dashboard/pyx-datasync',
    monitoringDetailStatus: '/v1_4/custom/qualita/dashboard/institute-status'
  },
  personalDashboardV2: {
    chartData: '/v1_4/personal-dashboard/get'
  },
  lookup: {
    list: '/v1_4/lookupvalue/list',
    parents: '/v1_4/lookup/list',
    create: '/v1_3/lookup/new',
    edit: '/v1_4/lookup/edit',
  },
  customer: {
    list: '/v1_4/customer/list',
    bulk:{
      delete: '/v1_4/customer/bulk/delete'
    }
  },
  menuPrivilege: {
    list: '/v1_4/menuprivilege/list'
  },
  team: {
    get: '/v1_4/team/get'
  },
  user: {
    updateFcm: '/v1_4/user/edit/firebase-token'
  },
  maps: {
    autocomplete: '/v1_4/maps/autocomplete',
    geocode: '/v1_4/maps/geocode'
  },
  pco: {
    flyCatcherDashboard: '/v1_4/custom/pco/dashboard/fly-catcher'
  },
  task: {
    // Task type
    types: '/v1_4/tasktype/list',
    type: '/v1_4/tasktype/get',
    typeLimitedTo: '/v1_4/tasktype/member_access_list',
    editTypeLimitedTo: '/v1_4/tasktype/member_access',
    createType: '/v1_4/tasktype/new',
    editType: '/v1_4/tasktype/edit',
    activateType: '/v1_3/tasktype/activate',
    inactivateType: '/v1_3/tasktype/inactivate',
    activateAction: '/v1_3/tasktype/action/activate',
    inactivateAction: '/v1_3/tasktype/action/inactivate',
    resultNew: '/v1_4/result/update',
    resultDocument: '/v1_4/result/update/upload-document',
    resultImage: '/v1_4/result/update/upload-image',
    resultSignature: '/v1_4/result/update/upload-signature'
  },
  taskType: {
    createAction: '/v1_4/tasktype/action/new',
    editAction: '/v1_4/tasktype/action/edit',
  },
  memberPrivilege: {
    list: '/v1_4/memberprivilege/list'
  },
  groupMember: {
    list: '/v1_4/groupmember/list'
  }
}

export default endpointConfig